import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getISCO3OccupationList = async (isco2Codes: string[]) => {
    const { path, method } = endpoints.occupationAndSector.getISCO3OccupationList;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { isco2Codes } ,
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
